import React from 'react';
import { Box, Typography } from '@mui/material';
import { BasicDialog, CustomButton, TextButton } from '../../../components';
import QuizIcon from '../../../assets/quiz-image.png';
import { useAppSelector } from '../../../redux';
import { userSelectors } from '../../../redux/user';
import { MatchingVIPosition } from 'src/types/videoInterviewData';

interface IProps {
  handleClose: () => void;
  handleStartRecord: (e: React.SyntheticEvent | null) => void;
  handleSkipSelection?: (e: React.SyntheticEvent | null) => void;
  handleCalendar: () => void;
  isTechQuestions?: boolean;
  isOpen: boolean;
  showSkipButton?: boolean;
  selectedVI?: MatchingVIPosition | null;
}

export const VideoInterviewDialog: React.FC<IProps> = ({
  handleStartRecord,
  handleClose,
  handleSkipSelection,
  handleCalendar,
  isOpen = true,
  showSkipButton,
  selectedVI,
}) => {
  const userData = useAppSelector(userSelectors.getUserData)!;
  const userReminderDate = userData.videoInterviewReminderDate;

  const onCreateVideoRecordClick = () => {
    handleStartRecord(null);
  };

  return (
    <BasicDialog
      isOpen={isOpen}
      handleClose={handleClose}
      maxWidth="34rem"
      overflowVisible
    >
      <Box
        component="img"
        srcSet={`${QuizIcon} 2x`}
        sx={(theme) => ({
          position: 'absolute',
          top: '2rem',
          transform: 'translateX(-55%)',
          left: '50%',
          maxWidth: '150px',
          [theme.breakpoints.up('sm')]: { top: '-5rem', maxWidth: '200px' },
        })}
      />
      <Typography variant="h2" textAlign="center" mt={26} mb={4}>
        Keep it casual <br /> while recording
      </Typography>
      <Typography variant="body1" textAlign="center" gutterBottom mb={3}>
        Just make sure you have {selectedVI?.viDuration} minutes for <br />
        the recording and focus on speaking <br /> naturally and avoid reading
        from a script.
      </Typography>
      <Box
        sx={{
          maxWidth: '300px',
          display: 'flex',
          justifyContent: showSkipButton ? 'space-between' : 'center',
          margin: '0 auto',
        }}
      >
        <CustomButton
          label="OK, record it"
          onClick={onCreateVideoRecordClick}
          color="primary"
        />
        {showSkipButton && (
          <CustomButton
            label="Skip it"
            onClick={handleSkipSelection}
            color="secondary"
          />
        )}
      </Box>
      <Box
        sx={{
          textAlign: 'center',
          mt: 3,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Prefer to do it later?
        </Typography>
        <TextButton onClick={handleCalendar}>
          {userReminderDate ? 'Reschedule event' : 'Add to your calendar'}
        </TextButton>
      </Box>
    </BasicDialog>
  );
};
